import React from 'react';
import { RadioButton } from 'primereact/radiobutton';
import { useLanguage } from '../../../../contexts/LanguageContext';

const RadioButtonGroup = ({ label, value, onChange, required = false, submitted = false, errorMessage, className = 'col-12', idPrefix, disabled = false, containerRef }) => {
    const { th } = useLanguage();
    const hasError = submitted && required && value === null;
    const safeIdPrefix = idPrefix || label?.replace(/\s+/g, '-').toLowerCase() || 'radio';

    return (
        <div className={className} ref={containerRef}>
            <div className="field">
                <label className="font-bold block mb-2">
                    {label} {required && '*'}
                </label>
                <div className="flex gap-4">
                    <div className="field-radiobutton">
                        <RadioButton inputId={`${safeIdPrefix}-yes`} value={true} checked={value === true} onChange={(e) => onChange(e.value)} disabled={disabled} />
                        <label htmlFor={`${safeIdPrefix}-yes`} className="ml-2">
                            {th('technicalSupport.yes')}
                        </label>
                    </div>
                    <div className="field-radiobutton">
                        <RadioButton inputId={`${safeIdPrefix}-no`} value={false} checked={value === false} onChange={(e) => onChange(e.value)} disabled={disabled} />
                        <label htmlFor={`${safeIdPrefix}-no`} className="ml-2">
                            {th('technicalSupport.no')}
                        </label>
                    </div>
                </div>
                {hasError && <small className="p-error">{errorMessage || th('technicalSupport.requiredField')}</small>}
            </div>
        </div>
    );
};

export default RadioButtonGroup;
